import { GenericTestRouteState } from './generic-test-state'

export const NutritionalTestRouteState = GenericTestRouteState.named(
  'NutritionalTestRouteState'
)
